import { isProjectArchived, isProjectCompleted } from '../../utils/projects';

/**
 * Renders project display name with optional status badges
 * (completed, archived, expedited, holds, and ordered stamp/package tags).
 * Strips a trailing "(Expedited)" suffix from stored names so it is not duplicated next to the tag.
 */
const stripTrailingExpeditedLabel = (name) => {
    if (name == null || typeof name !== 'string') return name;
    const stripped = name.replace(/\s*\(Expedited\)\s*$/i, '').trimEnd();
    return stripped.length > 0 ? stripped : name.trim();
};

export const ProjectNameWithStatus = ({ project, variant = 'table' }) => {
    const raw =
        project?.project_name ||
        project?.name ||
        project?.title ||
        'N/A';

    const base = raw === 'N/A' ? raw : stripTrailingExpeditedLabel(raw);

    const isCompleted = isProjectCompleted(project);
    const isArchived = isProjectArchived(project);

    const tags = (
        <>
            {isCompleted && (
                <span className="status-chip status-chip--sm status-chip--success">Completed</span>
            )}
            {isArchived && (
                <span className="status-chip status-chip--sm status-chip--archived">Archived</span>
            )}
            {project?.is_expedited && (
                <span className="status-chip status-chip--sm status-chip--warning">Expedited</span>
            )}
            {project?.manufacturing_hold && (
                <span className="status-chip status-chip--sm status-chip--hold">
                    Manufacturing Hold
                </span>
            )}
            {project?.engineering_hold && (
                <span className="status-chip status-chip--sm status-chip--hold">
                    Engineering Hold
                </span>
            )}
            {project?.shipping_hold && (
                <span className="status-chip status-chip--sm status-chip--info">
                    Shipping Hold
                </span>
            )}
            {variant === 'table' && project?.pe_stamps_ordered && (
                <span className="status-chip status-chip--sm status-chip--pending">
                    PE Stamps Ordered
                </span>
            )}
            {variant === 'table' && project?.op_package_ordered && (
                <span className="status-chip status-chip--sm status-chip--pending">
                    Optimization Package Ordered
                </span>
            )}
        </>
    );

    if (variant === 'heading') {
        return (
            <h1 className="project-title-with-status">
                <span className="project-title-with-status__name">{base}</span>
                <span className="project-title-with-status__tags">{tags}</span>
            </h1>
        );
    }

    return (
        <span className="project-name-with-status">
            <strong>{base}</strong>
            {tags}
        </span>
    );
};
